import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "secondary-font gap-4 mt-2 mb-6" }
const _hoisted_3 = { class: "s20 flex items-center pb-2 gap-6" }
const _hoisted_4 = { class: "s7" }
const _hoisted_5 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_6 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_7 = { class: "s7" }
const _hoisted_8 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_9 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_10 = { class: "s6" }
const _hoisted_11 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_12 = {
  class: "h-20 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_13 = { class: "secondary-font gap-4 mt-8 mb-6" }
const _hoisted_14 = { class: "grid2 px-1" }
const _hoisted_15 = { class: "s10" }
const _hoisted_16 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_17 = { class: "secondary-font font-semibold text-grey-900 py-1" }
const _hoisted_18 = { class: "secondary-font font-semibold text-purple" }
const _hoisted_19 = { class: "s10 text-right" }
const _hoisted_20 = {
  key: 0,
  class: "secondary-font font-semibold text-primary-color pb-1"
}
const _hoisted_21 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_22 = { class: "secondary-font font-semibold text-grey-600 py-1" }
const _hoisted_23 = {
  key: 0,
  class: "text-center text-grey-600 py-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, " Mon revolving sur " + _toDisplayString(_ctx.souscription?.duree_mois || 12) + " mois ", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
          _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
          _createTextVNode(" Décaissé ")
        ], -1)),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.formatAmount(_ctx.totalDecaisse)) + " F", 1),
        _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.decaissePourcent) + "%", 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
          _createElementVNode("div", { class: "circle-medium bg-purple" }),
          _createTextVNode(" A décaisser ")
        ], -1)),
        _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.formatAmount(_ctx.totalADecaisser)) + " F", 1),
        _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.aDecaisserPourcent) + "%", 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
          _createElementVNode("div", { class: "circle-medium bg-green-light" }),
          _createTextVNode(" Total ")
        ], -1)),
        _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.formatAmount(_ctx.totalGeneral)) + " F", 1),
        _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "h-100p flex align-items-center justify-content-left rounded-100 position-absolute text-xl bg-green-light",
        style: {"width":"100%"}
      }, null, -1)),
      _createElementVNode("div", {
        class: "h-100p flex align-items-center justify-content-left rounded-100 position-absolute text-xl bg-purple text-white",
        style: _normalizeStyle({ width: (parseFloat(_ctx.aDecaisserPourcent) + parseFloat(_ctx.decaissePourcent)) + '%' })
      }, null, 4),
      _createElementVNode("div", {
        class: "h-100p flex align-items-center justify-content-left rounded-100 position-absolute text-xl bg-color-1000 text-white",
        style: _normalizeStyle({ width: _ctx.decaissePourcent + '%' })
      }, null, 4)
    ]),
    _createElementVNode("h2", _hoisted_13, " Mois Revolving - " + _toDisplayString(_ctx.periodeLabel), 1),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: detail.id || index,
          class: _normalizeClass(["widget border shadow-200 rounded-30 gap-5 px-7 py-5", _ctx.cardClass(detail, index)])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h6", _hoisted_16, _toDisplayString(_ctx.formatDateFrench(detail.date_prevision)), 1),
            _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.formatAmount(Math.abs(detail.utilisation_mois || 0))) + " F", 1),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.detailPourcent(detail)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (detail.statut !== 'done' && _ctx.countdownText(detail))
              ? (_openBlock(), _createElementBlock("h5", _hoisted_20, _toDisplayString(_ctx.countdownText(detail)), 1))
              : _createCommentVNode("", true),
            (detail.statut === 'done')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
                ]))]))
              : _createCommentVNode("", true),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "secondary-font font-semibold text-grey-600 pt-1" }, "Date de déblocage", -1)),
            _createElementVNode("h6", _hoisted_22, _toDisplayString(_ctx.formatDateShort(detail.date_operation || detail.date_prevision)), 1)
          ])
        ], 2))
      }), 128))
    ]),
    (_ctx.details.length === 0 && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Aucun décaissement programmé "))
      : _createCommentVNode("", true),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}